import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet'; // Use react-helmet for managing head tags

const SEO = ({ title }) => {
  return (
    <Helmet>
      <meta charSet='utf-8' />
      <title>{title} - Evocation IT: Create Your Digital Landscape</title>
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string.isRequired,
};

// SEO.defaultProps = {
//   ogTitle: 'Evocation IT',
//   ogDescription: 'Evocation IT is a leading software development company specializing in custom software, SaaS, web & mobile applications, and cloud-based solutions to drive business success.',
//   ogImage: 'https://ia.media-imdb.com/images/rock.jpg', // Replace with your default image
//   ogUrl: window.location.href, // Dynamically set the URL to the current page
// };

export default SEO;